"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledActivePath = exports.StyledTrackPath = exports.Svg = void 0;

var _index = require("../styles/index.js");

var _styledComponents = require("../icon/styled-components.js");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var spin = {
  from: {
    transform: 'rotate(0deg)'
  },
  to: {
    transform: 'rotate(360deg)'
  }
};
/**
 * Spinner icon overrides
 */

var Svg = (0, _index.styled)('svg', function (props) {
  var $theme = props.$theme,
      $color = props.$color;
  return _objectSpread({}, (0, _styledComponents.getSvgStyles)(props), {
    fill: $color || $theme.colors.accent,
    cursor: 'wait',
    animationName: spin,
    animationDuration: $theme.animation.timing700,
    animationIterationCount: 'infinite',
    animationTimingFunction: 'linear'
  });
});
exports.Svg = Svg;
Svg.displayName = "Svg";
var StyledTrackPath = (0, _index.styled)('path', function (props) {
  return {
    fill: props.$theme.colors.spinnerTrackFill,
    opacity: 0.16
  };
});
exports.StyledTrackPath = StyledTrackPath;
StyledTrackPath.displayName = "StyledTrackPath";
var StyledActivePath = (0, _index.styled)('path', function (props) {
  return {
    fill: props.$color || props.$theme.colors.accent
  };
});
exports.StyledActivePath = StyledActivePath;
StyledActivePath.displayName = "StyledActivePath";